import { Button, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: any) => ({
    oneItemRow:{
        display: 'grid',
        gridTemplateColumns: '100%',
        gridTemplateRow: '100%'
    },
    buttonContainer:{
        display: 'grid',
        justifyContent: 'flex-end',
        gridTemplateColumns: '25% 25%',
        gridTemplateRow: '100%',
        columnGap: 15,
        width: '100%',
        paddingTop: 40,
    }
}));

interface Props {
    hidden: boolean
    setHidden: React.Dispatch<React.SetStateAction<boolean>>;
    postButtonText: string;
    isDelete: boolean
    deleteId?: string;
    postEntity?: () => void;
    postDeleteForEntity?: (id: string) => void;
    disabledPostButton?: boolean;
}

export const CancelCrudButtons: React.FC<Props> = ({hidden,setHidden,postButtonText,isDelete,deleteId,postEntity,postDeleteForEntity,disabledPostButton}) => {
    const classes = useStyles()
    
    return (
        <div className={classes.oneItemRow}>
                {
                    !isDelete ?
                    <div className={classes.buttonContainer}>
                        <Button variant="contained" onClick={() =>{setHidden(!hidden)}} style={{background: '#666666'}}>
                            Cancel
                        </Button>
                        <Button variant="contained" onClick={() => {postEntity && postEntity()}} disabled={disabledPostButton}>
                            {postButtonText}
                        </Button>
                    </div>
                    :
                    <div className={classes.buttonContainer}>
                        <Button variant="contained" onClick={() =>{setHidden(!hidden)}} style={{background: '#666666'}}>
                            Cancel
                        </Button>
                        <Button variant="contained" onClick={() => {postDeleteForEntity && postDeleteForEntity(deleteId ? deleteId : '')}} disabled={disabledPostButton} style={{background: '#b40000'}}>
                            {postButtonText}
                        </Button>
                    </div>
                }
        </div>
    )
}